import { APIRequest, createAPIActionGenerator } from 'utils/apidata';

export type UpdateOrganizationAvatarRequest = APIRequest<null> & {
  organizationUuid: string;
  image: File;
};

export const generators = {
  updateAvatar: createAPIActionGenerator<UpdateOrganizationAvatarRequest, null>(
    {
      prefix: 'ORGANIZATIONS/SETTINGS/AVATAR',
    }
  ),
};
